import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Menu, Dropdown, Avatar, Icon,
} from 'antd';
import { logoutRequest } from '../../redux/actions/account_actions/login.actions';

const mapStateToProps = (state) => {
    const { user: { person, _id, groups } } = state.App.App_content;
    return { person, _id, groups };
}; const Ava = `${process.env.PUBLIC_URL}/img/profile-male-circle2-512.png`; const
    MenuItem = Menu.Item;

export default connect(mapStateToProps, null)(class TopbarProfile extends Component {
  logoutUser = () => this.props.dispatch(logoutRequest(null));

  render() {
      const { person } = this.props;
      const menu = (
          <Menu>
              <MenuItem style={{ padding: 10 }} onClick={this.logoutUser}>
                  <Icon type="logout" style={{ marginTop: 5, marginRight: 10 }} />
                  <span>Log Out</span>
              </MenuItem>
          </Menu>
      );

      return (
          <Dropdown overlay={menu}>
              <div className="topbar__avatar-name">
                  <Avatar src={person.photos.small || Ava} />
                  <span style={{ marginLeft: 10, marginRight: 5 }}>
                      {`${person.first_name}  ${person.last_name}`}
                  </span>
                  <Icon type="down" />
              </div>
          </Dropdown>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/App/components/topbar/TopbarProfile.js